





























































































































import Vue from "vue";
import Cookie from "js-cookie";
import TheLayoutFooter from "@/components/TheLayoutFooter.vue";
export default Vue.extend({
  components: { TheLayoutFooter },
  data() {
    return {
      advantageList1: [
        " 人才码头专注做候选人能力评估，为多家企业及平台量身定制多维度职位标准",
        " 人才码头为企业提供专业的人才技能评估报告与职位-候选人的匹配度报告",
        " 人才码头大幅提升招聘环节的面试效率及后续转正效率",
      ],
      advantageList2: [
        " 人才码头联手各大高校，全面推广技能测评",
        " 学生在小程序申请直通卡，企业可一键审核",
        " 人才码头极大提升了企业的校招效率",
      ],
      advantageList3: [
        {
          img: require("@/assets/images/icon-circle.png"),
          title: "数据化",
          content: "技能掌握情况数据化",
        },
        {
          img: require("@/assets/images/icon-eye.png"),
          title: "可视化",
          content: "候选人技能可视化",
        },
        {
          img: require("@/assets/images/icon-trangle.png"),
          title: "标准化",
          content: "量身定制的标准化服务",
        },
        {
          img: require("@/assets/images/icon-next.png"),
          title: "一站式",
          content: "一站式招聘管理",
        },
        {
          img: require("@/assets/images/icon-easy.png"),
          title: "操作简单",
          content: "仅需一步即可完成评估",
        },
        {
          img: require("@/assets/images/icon-lighting.png"),
          title: "效率提升",
          content: "有效提升招聘效率",
        },
      ],
    };
  },
  computed: {
    getBanner() {
      return (param: string) => {
        return param == "pass"
          ? require("@/assets/images/icon-pass.png")
          : require("@/assets/images/icon-step.png");
      };
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let fixOffset = window.pageYOffset;
      if (fixOffset >= 300) {
        fixOffset = 300;
      }
      this.bannerPosition = fixOffset;
    },
    handleApplyTrial() {
      this.$router.push({ name: "applyTrial" });
    },
    handleLogin() {
      let role = Cookie.get("web_user_role");
      switch (role) {
        case "1":
          window.location.href = process.env.VUE_APP_EDU_URL;
          break;
        case "2":
          window.location.href = process.env.VUE_APP_HR_URL;
          break;
        default:
          this.$router.push({ name: "login" });
      }
    },
    handleOpen() {
      window.open("/service-protocol.html");
    },
  },
});
